import React, { useState } from "react";
import { IProps } from "./types";
import { getPriceWithFraction } from "@utils";
import SimplLogo from "./images/simpl_logo.png";
import { styled } from "@styles";
import { caption, subtitle2 } from '@typo/typo.module.css';
import { textPrimary, textSecondary } from '@typo/color.module.css';
import { SimplTooltipModal } from "@atoms/SimplTooltipModal";
import InfoIcon from "@src/componentsNew/Icons/Icons/InfoIcon";

const SimplLogoImg = styled.img`
  padding-right: 0.4rem;
  width: 3.2rem;
`;

const SimplePricePreview: React.FC<IProps> = ({ price, isBeautyDeviceProductInSelectedCart }: IProps) => {
  const splitCalulate = (price) => {
    const div = price / 3;
    const pow = Math.pow(10, 2);
    const final = Math.round(div * pow) / pow;
    return final;
  };

  const beautyDeviceSplitCalulate = (price) => {
    const div = price / 24;
    const pow = Math.pow(10, 2);
    const final = Math.round(div * pow) / pow;
    return final;
  };

  const [showSimplTooltip, setShowSimplTooltip] = useState(false);
  const handleSimplTooltipShow = () => {
    setShowSimplTooltip(true);
  }

  const handleSimplTooltipClose = () => {
    setShowSimplTooltip(false);
  }

  return (
    <>
      <span>
        {
          isBeautyDeviceProductInSelectedCart ?
            <>
              <label className={[caption, textSecondary].join(' ')}>or upto 24 months EMI available&nbsp;</label>
              <label className={[subtitle2, textPrimary].join(' ')}>{`(${getPriceWithFraction(beautyDeviceSplitCalulate(price), true, true)} + interest) / month`}</label>
              <label className={[caption, textSecondary].join(' ')}>&nbsp;* interest will be differ by bank &nbsp;</label>
            </>
            :
            <>
              <label className={[caption, textSecondary].join(' ')}>or 3 interest free payments of&nbsp;</label>
              <label className={[subtitle2, textPrimary].join(' ')}>{getPriceWithFraction(splitCalulate(price), true, true)}</label>
              <label className={[caption, textSecondary].join(' ')}>&nbsp;with &nbsp;</label>
            </>
        }

        {
          isBeautyDeviceProductInSelectedCart ?
            null :
            <>
              <SimplLogoImg src={SimplLogo} />

              <InfoIcon onClick={handleSimplTooltipShow} />
            </>
        }

        <SimplTooltipModal show={showSimplTooltip} onHide={handleSimplTooltipClose} />
      </span>
    </>
  );
}

export { SimplePricePreview }
